/**
 * Modulo Externals
 * @module abstracts/externals
 * @namespace Abstracts/Externals
 */
import _ from 'underscore'
import Core from '../core'

/**
 * Classe responsável por cadastrar e disparar eventos
 *
 * @name Externals
 * @typedef {Object} Externals
 * @memberof abstracts/console
 */
class Externals {
    /**
     * Constructor da classe Externals
     * Sobrescrever a variável global GPExternalFunctions por essa classe
     *
     * @return {void}
     */
    constructor () {
        Core.Status.update('externals', 'status', 'started')

        // Clonou a variável global
        const GlobalExternals = _.clone(window.GPExternalFunctions || [])

        // Definiu a variável global como o Objeto Externals
        window.GPExternalFunctions = this

        if (Array.isArray(GlobalExternals) && GlobalExternals.length > 0) {
            for (let i = 0; i < GlobalExternals.length; i++) {
                const fn = GlobalExternals[i]
                this.addFunction(fn)
            }
        }

        Core.Status.update('externals', 'status', 'finished')
    }

    /**
     * Sobrescreve a função push nativa do array GPExternalFunctions
     *
     * @param {function} fn
     */
    push (fn) {
        try {
            if (typeof fn !== 'function') {
                throw new Error('Deve ser uma função')
            }

            this.addFunction(fn)
        } catch (ex) {
            console.error(ex)
        }
    }

    /**
     * Registra a função como uma tarefa
     *
     * @param {function} fn
     */
    addFunction (fn) {
        try {
            if (typeof fn !== 'function') {
                throw new Error('Deve ser uma função')
            }

            Core.Tasks.add(Core.Events.PAGE_COMPLETE, fn)
        } catch (ex) {
            console.error(ex)
        }
    }
}

window.GPAbstractModules = window.GPAbstractModules || {}
window.GPAbstractModules.Externals = Externals
